import { useMatches } from 'react-router';

import {
    PROFESSIONAL_DETAILS_BASE_ROUTE_ID,
    PREVIEW_BASE_ROUTE_ID,
} from '@modules/business-manager/config/constants';
import type { ProfileFamily } from '@modules/professional/util/derive-profile-family';

/**
 * The profile family the root professional loader derived, from any component
 * under the professional detail (or preview) layout. Null when the profile is
 * not part of a family — or on the preview route, whose loader doesn't
 * provide one.
 */
export const useProfileFamily = (): ProfileFamily | null => {
    const matches = useMatches();
    const route = matches.find((match) =>
        [PROFESSIONAL_DETAILS_BASE_ROUTE_ID, PREVIEW_BASE_ROUTE_ID].includes(
            match.id,
        ),
    );
    const data = route?.data as
        | { profileFamily?: ProfileFamily | null }
        | undefined;
    return data?.profileFamily ?? null;
};
